var HomeController = /** @class */ (function () {
    /**
     * 
     * @param $scope
     * @param localStorageService
     * @param $message
     * @param MKioskService
     * @param $timeout
     * @param $interval
     * @param $mdDialog
     * @param $state
     * @param $q
     * @param $translationService
     * @param cacheMemoryService
     * @param ChargeRequestService
     * @param AuthService {AuthService}
     * @param $stateParams{angular.ui.IStateParamsService}
     * @param $Loading{$Loading}
     * @param $http{angular.IHttpService}
     * @param UtilityService{UtilityService}
     * @param NetworkInfoService{NetworkInfoService}
     * @param DeviceService{DeviceService}
     * @param NotificationService{NotificationService}
     * @param $mdPanel{$mdPanel}
     * @constructor
     */
    function HomeController($scope, localStorageService, $message,
                            MKioskService, $timeout, $interval, $mdDialog,
                            $state, $q, $translationService, 
                            cacheMemoryService, ChargeRequestService, AuthService,
                            $stateParams, $Loading, $http, UtilityService, NetworkInfoService,
                            DeviceService,
                            NotificationService,
                            $mdPanel) {

        var _this = this;
        this.$scope = $scope;
        this.localStorageService = localStorageService;
        this.$message = $message;
        this.MKioskService = MKioskService;
        this.$timeout = $timeout;
        this.$mdDialog = $mdDialog;
        this.$state = $state;
        this.$q = $q;
        this.$translationService = $translationService;
        this.$interval = $interval;
        this.isShownStats = false;
        this.homeDataRefreshInterval = null;
        this.driverstatsCache = cacheMemoryService.get("homepage");
        this.chargeRequestService = ChargeRequestService;
        this.AuthService = AuthService;
        this.$stateParams = $stateParams;
        this.$Loading = $Loading;
        this.$http = $http;
        this.utilityService = UtilityService;
        this.networkInfoService = NetworkInfoService;
        this.deviceService = DeviceService;
        this.notificationService = NotificationService;
        this.$mdPanel = $mdPanel;
        this.destroyed = false;
        
        // NF-806: some cy dont want to show estimation km
        this.hideAutonomyEstimation = false;

        this.stats = {
            SolarPowered: 0,
            ElectricDriven: 0,
            EnergyEfficientUnit: ''
        };
        /** @type {IAuthenticatedUser} */
        this.homeData = {
            RecentCharge: null,
            ActiveCharges: [],
            DueTodayChargeBookings: 0,
            PendingChargeBookings: 0,
            UnreadEvents: 0,
            ActiveVehicleBookings: 0,
            PendingVehicleBookings: 0
        };
        this.modules = {};
        this.chartData = {};
        this.linePosition = 0;
        this.energyEfficientUnitFirst = '';
        this.energyEfficientUnitSecond = '';
        this.chartReady = false;
        // this.minHeightContent = 0;
        this.vehicles = [];
        this.availableVehicles = [];
        this.loading = false;
        this.$element = $('#internal-home-page');
        this.modules = this.getAvailabilityModules();
        this.isShownStats = this.checkShownStats();

        // This is a custom array which will bind with header to show current charge status
        this.chargingStatus = [];

        // this._lastRefreshMoment = null;
        // first login or hidden is default
        if (!this.isShownStats) {
            this.$element.find('.card-solar').removeClass('visible').addClass('hidden');
        }

        
        // Vehicles, get cache first to make sure user atlest have current data to work to avoid block screen always
        this.vehicles = this.driverstatsCache.get('vehicles');

        
        this.refreshHomepageData().finally(()=>{
            // Hide SplashScreen when  load data complete
            this.$timeout(()=>{
                this.utilityService.hideSplashscreen();
            }, 1000) // delay for rendering
        })

        this.watch();
        this.bindEvents();
    }

    HomeController.prototype.watch = function () {
        var _this = this;
        this.$scope.$watch("vm.isShownStats", function (newValue, oldVlue) {
            if (newValue !== oldVlue) {
                if (newValue) {
                    _this.$element.find(".card-solar").addClass("visible").removeClass("hidden");
                } else {
                    _this.$element.find(".card-solar").addClass("hidden").removeClass("visible");
                }
            }
        });

    };
    HomeController.prototype.bindEvents = function () {
        var _this = this;
        var delay = (function () {
            var timer = 0;
            return function (callback, ms) {
                clearTimeout(timer);
                timer = setTimeout(callback, ms);
            };
        })();
        $(window).resize(function () {
            delay(function () {
                _this.onResize();
                _this.safeApply();
            }, 500);
        });
        // Listen on vehicles change
        // this.stopListenVehicles = this.vehicleService.onVehiclesChange(function (vehicles) {
        //     _this.vehicles = vehicles;
        // });
        this.$scope.$on('$destroy', function () {
            _this.destroyed = true;
            _this.onDestroy();
        });
        // we dont need it for the moment as we already have pull to refresh but need to see
        // $(window).bind('focus.home', function () {            
        //     _this.onFocus();
        // });

        // Refresh home data every 1 minute
        let startRegisterRefreshEveryMinutes = function(){
            // To make sure only have 1 interval to refresh home data, so when start a new interval we will cancel the old one first
            if(_this.homeDataRefreshInterval) {
                _this.$interval.cancel(_this.homeDataRefreshInterval);
            }
            _this.homeDataRefreshInterval = _this.$interval(function () {
                // Don't refresh if Update dialog is openning or network is disconnected
                if( _this.deviceService.isAppInBackground || // App in background
                    !_this.networkInfoService.connection || // No network
                    _this.notificationService.currentDialogUrgentRef || // Notification dialog is opening
                    _this.notificationService.panelRef || // Notification dialog is opening
                    _this.AuthService.showingUpdateRequired() ||  // Update required dialog is opening
                    _this.AuthService.showingChangePassword ||  // Change password dialog is opening
                    !_this.AuthService.isLoggedIn() // User is not logged in 
                ) {
                    return;
                }
                _this.refresh(false);
            }, 1000 * 60); // 1 minute
        }

        // Start Refresh home data every 1 minute
        startRegisterRefreshEveryMinutes();
        
        //NF-968: Refresh screen when resume app (Switch app from background to foreground)
        this.unregisterResume = this.deviceService.onResume(function () {
            // Don't check anything if don't have connection
            if(!_this.networkInfoService.connection) {
                return ;
            }
            
            // NF-968: Refresh all data on screen (vehicles, driver stats)
            _this.refresh().finally(()=>{
                // Stop interval to prevent register 2 times
                _this.$interval.cancel(_this.homeDataRefreshInterval);

                // Start Refresh home data every 1 minute when component is not destroyed
                if(!_this.destroyed) {
                    startRegisterRefreshEveryMinutes();
                }
            });
           
        });

        // Stop interval when app in background to prevent refresh 2 times when app resume
        this.unregisterPause = this.deviceService.onPause(function () {
            _this.$interval.cancel(_this.homeDataRefreshInterval);
        });

        // NF-961: Make new request
        this.$scope.$on('make-a-new-charge-request',()=>{
            this.onNewChargeRequestClick();
        });

        // NF-948, Refresh home data when event is received
        this.$scope.$on('refresh-home-data',()=>{
            this.refreshHomepageData();
        });
    };
    HomeController.prototype.refreshHomepageData = function () {
        return this.refresh()
            // Don't need to check urgent notification here anymore as we have done it when app resume
            .then(() => {
                // Check urgent notifications when call refresh-home-data, go to homepage screen
                this.notificationService.checkUrgentNotifications().then(() => {
                    this.notificationService.checkNotificationCount();
                })
            })
            .finally(this.$Loading.blockUI());
    };
    
    HomeController.prototype.onResize = function () {
        this.resizeChart();
    };
    HomeController.prototype.onDestroy = function () {
        // this.stopListenVehicles();        
        this.$interval.cancel(this.homeDataRefreshInterval);
        
        // Unregister resume/pause event
        this.unregisterResume();
        this.unregisterPause();
        // $(window).off('focus.home');
    };
    HomeController.prototype.getDriverStats = function () {
        return this.MKioskService.getDriverstats().then(function (stats) {
            if (!stats.ElectricDriven) {
                stats.ElectricDriven = 0;
            }
            return stats;
        });
    };
    HomeController.prototype.getAvailabilityModules = function () {
        var results = {};

        if (this.homeData && this.homeData.Modules) {
            _.each(this.homeData.Modules, function (value) {
                results[value] = 1;
            });
        } else {
            var user = this.AuthService.getAuthenticatedUser();
            if (user) {
                _.each(user.Modules, function (value) {
                    results[value] = 1;
                });
            }
        }

        return results;
    };
    HomeController.prototype.checkShownStats = function () {
        var value = sessionStorage.getItem("Neo-Fleet-DisplayEnergyCard");
        if (value) {
            return value === "true" || value === "1";
        } else {
            return false;
        }
    };
    HomeController.prototype.setDisplayEnergyCardToCache = function (value) {
        // convert null, undefined to false
        if (!value)
            value = false;
        sessionStorage.setItem("Neo-Fleet-DisplayEnergyCard", value);
    };
   
    HomeController.prototype.restoreStats = function (stats) {
        // chart data
        this.chartData = {
            MaxPower: _.max(Array.prototype.concat([stats.AverageEnergyEfficienty], stats.EnergyEfficientyPerPeriod)),
            Values: stats.EnergyEfficientyPerPeriod,
            Periods: stats.Periods
        };
        // avg line
        var avg = this.chartData.MaxPower === 0 ? 0 : (stats.AverageEnergyEfficienty / this.chartData.MaxPower);
        this.linePosition = 100 - (avg * 100);
        // avg text and unit
        this.energyEfficientUnitFirst = "";
        this.energyEfficientUnitSecond = stats.EnergyEfficientUnit;
        if (stats.EnergyEfficientUnit) {
            if (stats.EnergyEfficientUnit.split("/").length == 2) {
                this.energyEfficientUnitFirst = stats.EnergyEfficientUnit.split("/")[0];
                this.energyEfficientUnitSecond = stats.EnergyEfficientUnit.split("/")[1];
            }
        }
    };

    HomeController.prototype.safeApply = function (fn) {
        var phase = null;
        if (this.$scope.$root && this.$scope.$root.$$phase) {
            phase = this.$scope.$root.$$phase;
        }
        if (phase === '$apply' || phase === '$digest') {
            if (fn && (typeof (fn) === 'function')) {
                fn();
            }
        } else {
            this.$scope.$apply(fn);
        }
    };
    HomeController.prototype.getMinHeightContent = function () {
        return $(window).height() - 56;
    };

    /**
     * Get Vehicles
     * @returns {angular.IPromise<IVehicle[]>|*}
     */
    HomeController.prototype.getVehicles = function () {
        return this.MKioskService.getMyVehicles();
    };

    /**
     * Sample of data model of home data:
     * {
            "UserName": "Hoang",
            "AvatarUrl": "http://frederic/neofleet/logo/f322fa56-bfcf-4a9d-94db-94570bda38f0.jpg",
            "Modules": [
                "ChargeRequest",
                "ChargeBookings",
                "Events",
                "HomeCharges",
                "VehicleBookings"
            ],
            "RecentCharge": null,
            "ActiveCharges": [{
                "ChargingPoint": "28",
                "Vehicle": "1-YBT-174 - Electric 1",
                "ChargeAtArrival": 30,
                "EstimatedCurrentCharge": 30,
                "PowerConsumedDuringCharging": null,
                "VehicleAutonomyOnFullCharge": 120,
                "ChargeWarning": false
            }],
            "DueTodayChargeBookings": 0,
            "PendingChargeBookings": 0,
            "UnreadEvents": 2,
            "ActiveVehicleBookings": 3,
            "PendingVehicleBookings": 1,
            "QueuedChargeRequest": null,
            "ReneweableEnergyType": "Green"
        }
     */
    HomeController.prototype.updateHomeScreenData = function () {
        var _self = this;
        return this.AuthService.refreshHomeData().then(function (data) {
            _self.homeData = data;
            
            // Update Recent Charge
            if (_self.homeData.RecentCharge) {
                var dateTime = moment(_self.homeData.RecentCharge.EndDateTime);
                _self.homeData.RecentCharge.endDate = dateTime.format('DD/MM/YYYY');
                _self.homeData.RecentCharge.endTime = dateTime.format('HH:mm');
            }           

            _self.modules = _self.getAvailabilityModules();
            _self.driverstatsCache.set('modules', _self.modules);
            sessionStorage.setItem('licenseType', _self.homeData.LicenseType);            

            // build chage status
            var chargingStatus = [];
            if ((_self.homeData.ActiveCharges || []).length > 0) {
                for(let activeCharge of _self.homeData.ActiveCharges) {
                    chargingStatus.push({
                        Model: activeCharge.Vehicle,
                        Charging: true,
                        ChargeStatus: 'Active',
                        ChargingPointName: activeCharge.ChargingPoint
                    });
                }
            } else if ((_self.homeData.QueuedChargeRequests || []).length > 0) {

                for(let queue of _self.homeData.QueuedChargeRequests) {
                    chargingStatus.push({
                        Model: queue.Vehicle,
                        Charging: true,
                        ChargeStatus: 'Disconnected'
                    });
                }
                
            }

            _self.chargingStatus = chargingStatus;
            // NF-806: HideAutonomyEstimationForChargeOnMobile 
            _self.hideAutonomyEstimation = _self.homeData.HideAutonomyEstimationForChargeOnMobile;

            return true;
        });
    };   

    HomeController.prototype.onNewChargeRequestClick = function () {
        if (this.homeData.DueTodayChargeBookings > 0) {
            this.newChargeRequestFromDueChargeBookings();
        } else {
            this.newChargeRequestFromVehicles();
        }
    };

    HomeController.prototype.newChargeRequestFromVehicles = function () {
        if (this.vehicles.length === 0) {
            //NoElectricOrHybridVehicleAssignedToYou
            var alert_1 = this.$mdDialog.alert()
                // .textContent("No electric or hybrid vehicle assigned to you.")
                .textContent(this.$translationService.getTranslation('NoElectricOrHybridVehicleAssignedToYou'))
                .ok(this.$translationService.getTranslation('OK'))
                .clickOutsideToClose(true);
            return this.$mdDialog.show(alert_1);
        }
        if (this.vehicles.length >= 2) {
            this.showVehicleModal();
        }
        else {
            var vehicle = this.vehicles[0];
            this.gotoChargingRequest(vehicle.Id);
        }
    };

    HomeController.prototype.newChargeRequestFromDueChargeBookings = function () {
        let self = this;

        this.chargeRequestService.getChargeBookingsDueToday().then(function (items) {
            var vehiclesInBooking = [];

            for (var booking of items) {
                vehiclesInBooking.push({
                    Id: booking.Id,
                    VehicleId: booking.VehicleId,
                    Model: booking.VehicleModel,
                    Name: `${booking.VehicleName}   (${booking.StartTime} - ${booking.EndTime})`,
                    SiteName: booking.SiteName,
                    $originalBooking: booking
                });
            }

            self.showChargeBookingsSelection(vehiclesInBooking).then(function (booking) {
                self.$state.go('internal.chargingrequest', { context: "chargebooking", contextId: booking.Id });
            }, function (cancel) {
                self.newChargeRequestFromVehicles();
            });
        });
    };

    HomeController.prototype.onQueuedChargeRequestClick = function (chargeRequest) {
        this.gotoChargingRequest(chargeRequest.VehicleId, chargeRequest.ChargeMadeUponReturnOfVehicleBookingId);
    };
    HomeController.prototype.showChargeBookingsSelection = function (vehicles) {
        var title = this.$translationService.getTranslation('DueChargeBooking');
        var msg = vehicles.length === 1 ? 
                this.$translationService.getTranslation('AreYouCreatingChargeRequestRelationToThisBooking') :
                this.$translationService.getTranslation('AreYouCreatingChargeRequestRelationToTheseBookings');

        return this.$mdDialog.show({
            controller: VehiclesModalController,
            controllerAs: 'vm',
            templateUrl: 'js/internal/vehicles/vehicles-modal.view.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            escapeToClose: true,
            locals: {
                vehicles: vehicles,
                options: {
                    title: title,
                    contextMessage: msg,
                    // contextMessage: vehicles.length === 1 ?
                    //     'Are you creating a charge request in relation to this charge booking?' :
                    //     'Are you creating a charge request in relation to one of these charge bookings?',
                    dismissText: this.$translationService.getTranslation('No'),
                    confirmText: this.$translationService.getTranslation('Yes')
                }
            }
        });
    };

    HomeController.prototype.showVehicleModal = function () {
        var _this = this;
        this.$mdDialog.show({
            controller: VehiclesModalController,
            controllerAs: 'vm',
            templateUrl: 'js/internal/vehicles/vehicles-modal.view.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            escapeToClose: true,
            locals: {
                vehicles: this.vehicles,
                options: {
                    contextMessage:this.$translationService.getTranslation('WhichVehicleWillYouDriveToday')
                }
            }
        }).then(function (vehicle) {
            _this.gotoChargingRequest(vehicle.Id);
        });
    };

    HomeController.prototype.onActiveChargeRequestClick = function (activeCharge) {        

        // NF-1383 (2026.2.6) in case there is no vehicle id, we just can work with active charge id
        if (activeCharge.VehicleId) {
            this.gotoChargingRequest(activeCharge.VehicleId);
        } else if (activeCharge.Id) {
            // ID in this case is charge session id
            this.gotoChargingRequest(null, null, activeCharge.Id);
        }
        
    };
    // NF-1383 (2026.2.6) in case there is no vehicle id, we just can work with active charge id
    HomeController.prototype.gotoChargingRequest = function (vehicleId, vehicleBookingId, chargeSessionId) {
        // NF-535: in case the vehicle in queued charge, we need to change status of the the vehicle so that recognize in charge request state
        if (this.homeData.QueuedChargeRequest) {
            let queuedId = this.homeData.QueuedChargeRequest.VehicleId;
            let vehicles = this.driverstatsCache.get('vehicles');
            let v = _.find(vehicles, function(v) { return v.Id ===  queuedId; });

            if (v && v.ChargeStatus == null) {
                v.ChargeStatus = "Queued";
            }
        }
        if (chargeSessionId) {
            return this.$state.go("internal.chargingrequest", { context:"activeCharge", contextId: chargeSessionId });
        }

        if(vehicleBookingId) {
            return this.$state.go("internal.chargingrequest", {
                context:"vehiclebooking",
                contextId: vehicleBookingId
            });
        } else{
            return this.$state.go("internal.chargingrequest", { context:"vehicle", contextId: vehicleId });
        }
    };

    /**
     * @param {IVehicle} vehicle
     */
    HomeController.prototype.onChargingVehicleClick = function (vehicle) {
        this.gotoChargingRequest(vehicle.Id);
    };
    HomeController.prototype.resizeChart = function () {
        this.$element.find('nf-energy-efficient-chart').triggerHandler('resize');
    };
    HomeController.prototype.processVehicles = function (vehicles) {
        this.vehicles = vehicles;
        this.driverstatsCache.set('vehicles', this.vehicles);
    };
    /**
     * Process stats and draw chart
     * @param stats
     */
    HomeController.prototype.processStats = function (stats) {
        var _this = this;
        this.stats = stats;
        // Save to cacache
        // this.driverstatsCache.set('driverstats', stats);
        // draw chart
        this.restoreStats(stats);

        //Check DisplayEnergyCard to hide or show this card
        if (this.stats.DisplayEnergyCard !== this.isShownStats) {
            this.setDisplayEnergyCardToCache(this.stats.DisplayEnergyCard);
            this.$element.find(".card-solar").addClass("animation");
            this.isShownStats = this.stats.DisplayEnergyCard;
            if (this.isShownStats) {
                this.$element.addClass('animation-hide-chart');
                this.$timeout(function () {
                    _this.chartReady = true;
                    _this.$element.addClass('animation-show-chart');
                    _this.$timeout(function () {
                        _this.$element.removeClass('animation-hide-chart').removeClass('animation-show-chart');
                    }, 1000);
                }, 1000);
            }
        } else {
            if (this.isShownStats) {
                this.chartReady = true;
            }
        }
    };

    /**
     * Refresh data

     * @param [shouldRefreshVehicles] {boolean} Is refresh my vehicles
     * @returns {angular.IPromise<any>}
     */
    HomeController.prototype.refresh = function (shouldRefreshVehicles) {
        if(shouldRefreshVehicles === undefined || shouldRefreshVehicles === null){
            shouldRefreshVehicles = true;
        }
        if (this.loading) {
            return this.$q.resolve();
        }
        this.loading = true;
        let promises = [
            this.getDriverStats().then((driverStats) => {
                this.processStats(driverStats);
                return driverStats;
            }),
            this.updateHomeScreenData().then((homeData)=>{
                // NF-1246: Don't show tip when show password
                if(!this.AuthService.showingChangePassword){
                    this.showTipOfTheDay();
                }
                return homeData;
            })
        ];
        if(shouldRefreshVehicles){
            promises.push(this.getVehicles().then((vehicles) => {
                this.processVehicles(vehicles);
                return vehicles;
            }))
        }
        return this.$q.all(promises)
            .catch(this.$message.error)
            .finally(() => {
                this.loading = false;
            });
    };
    HomeController.prototype.doRefresh = function () {
        this.refresh().finally(()=>{
            this.$scope.$broadcast('scroll.refreshComplete');
        });
    };
    HomeController.prototype.onChargeBookingsClick = function () {
        this.$state.go("internal.chargebookings");
    };

    HomeController.prototype.markChargingPointAsFree = function ($event) {
        if (this.homeData && this.homeData.RecentCharge && !this.homeData.RecentCharge.VehicleMovedOut) {
            var _self = this;
            this.$Loading.show();
            this.chargeRequestService.markCharginPointAsFree(this.homeData.RecentCharge.Id).then(function (res) {
                _self.homeData.RecentCharge.VehicleMovedOut = res.VehicleMovedOut;
            }).finally(function () {
                _self.$Loading.hide();
            });
        }
    };

    HomeController.prototype.showTipOfTheDay = function () {

        var dayTip = this.AuthService.getUserLocalValue('tip-of-the-day');

        var shouldShowDayTip = true;
        if (dayTip) {
            var lastShow = moment(dayTip.lastShow, "YYYY-MM-DD HH:mm:ss");

            if (lastShow.isValid()) {
                // is last show was before today
                shouldShowDayTip = lastShow.diff(moment(), 'd') < 0;
            }
        } else {
            dayTip = {};// init in case we can save again later
        }        
        
        // NF-1122 to avoid disturb user the process only run after 12PM
        if (new Date().getHours() < 12) {
            return;
        }

        if (shouldShowDayTip) {

            var lastId = dayTip.lastId || -1;
            // get news list
            this.$http.get(`news/news.json?v=${Date.now().toString()}`).then((response) => {
                var news = response.data || [];
                news = Object.values(news).sort((a,b) => a.id - b.id);
                var newsToShow = null;

                for(n of news) {
                    if (n.id > lastId) {

                        // Tip define only 1 license name but for greater license we still can show
                        var licOk = true;
                        if (n.license) {
                            var lics = ['Charge', 'Refund', 'Optimize', 'Manage'];

                            // To avoid typo mistake with licence name
                            var moduleLicIndex = lics.indexOf(n.license);
                            licOk = moduleLicIndex >= 0 &&  moduleLicIndex <= lics.indexOf(this.homeData.LicenseType);
                        }

                        // if licence of -> check module
                        var moduleOk = true;
                        if (licOk) {
                            if (n.module) {
                                moduleOk = false;
                                var modules = this.getAvailabilityModules();
                                if (modules[n.module]) { moduleOk = true; }
                            }
                        }

                        // NF-945: if lic and module defined on a news are ok, then we start to check if environment ok (web or Cordova)
                        if (licOk && moduleOk) {
                            // If app run in Cordova mode then we check if the news can show in Cordova mode or web mode
                            if(window['cordova']) {
                                if (n.cordova) {
                                    newsToShow = n;
                                }
                            } else {
                                if (n.web) {
                                    newsToShow = n;
                                }
                            }
                        }
                    }

                    // If we found onw news to show then stop to loop next news
                    if (newsToShow) { break; }
                }

                if (newsToShow) {
                    this.notificationService.setWhatNews(newsToShow);
                }
            });
        }
        
    };

    /**
     * Handle driver required action click
     * - Show input mileage dialog if action type is InputMileage (NF-1171)
     * - Process notification if action have NotificationId
     * @param action {DriverRequiredAction}
     * @param $event {MouseEvent}
     */
    HomeController.prototype.onDriverRequiredActionClick = function (action, $event) {
        //NF-1171: Show input mileage dialog if action type is InputMileage
        if(action.Type === 'InputMileage') {
            this.showInputMileage(action, $event).then((result)=>{
                if(result) {
                    this.refresh();
                }
            })
            return;
        }

        if (action.NotificationId) {
            this.$Loading.show();
            this.notificationService.getNotification(action.NotificationId)
                .then((notificationItem) => {
                    this.$Loading.hide();
                        if (notificationItem.Urgent) {
                            this.notificationService.processNotification(notificationItem, {
                                isNotificationOnNotificationsModule: true,
                                $event: $event
                            });
                        } else {
                            // when its not urgent anymore then try to reload the dashboard so that user dont see again the item
                            return this.refresh().finally(() => {
                                this.$message.infor('msgActionRequiredCancelled');
                            });
                        }
                    },
                    (error) => {
                    this.$Loading.hide();
                        this.$message.error(error);
                        // Follow logic of NF-1104, mark the notifcaion as read then refresh the list when liked entity have been deleted
                        if (error.data.code == 'LinkedEntityIsNowDeleted') {
                            this.markAsRead(item.Id);
                        }

                        return Promise.reject(error);
                    });
        }
        
    };    




    /**
     * Show input mileage screen
     * @param action {DriverRequiredAction}
     * @param $event {MouseEvent}
     */
    HomeController.prototype.showInputMileage = function (action,  $event) {
        /** @type {MdPanelRef} panelRef */
        return this.$q((resolve) => {
            let panelRef;
            let config = {
                attachTo: document.body,
                controller: InputMileageController,
                templateUrl: 'js/internal/input-mileage/input-mileage.html',
                targetEvent: $event ? $event.target : null,
                clickOutsideToClose: false,
                escapeToClose: false,
                focusOnOpen: false,
                panelClass: 'panel-md-dialog',
                controllerAs: 'vm',
                hasBackdrop: true,
                locals: {
                    close: (result) => {
                        return panelRef.close(result).finally(() => {
                            resolve(result);
                        })
                    },
                    action: action
                },
                zIndex: 70,
            }
            panelRef = this.$mdPanel.create(config);
            panelRef.open();
        });
        
    };
    
    HomeController.$inject = [
        '$scope', 
        'localStorageService', 
        '$message', 
        'MKioskService', 
        '$timeout', 
        '$interval', 
        '$mdDialog', 
        '$state',
        '$q', 
        '$translationService',
        'CacheMemoryService',
        'ChargeRequestService',
        'AuthService',
        '$stateParams',
        '$Loading',        
        '$http',
        'UtilityService',
        'NetworkInfoService',
        'DeviceService',
        'NotificationService',
        '$mdPanel'
    ];
    return HomeController;
}());
angular.module('internal.home').controller('HomeCtrl', HomeController);
